import { Button, DataTable } from "@/components";

import { FaPlus } from "react-icons/fa6";
// import {
// } from "../../../app/slices";
import { useCallback, useEffect, useMemo, useState } from "react";
import ColumnHelper from "@/utils/ColumnHelper";
import { useDispatch, useSelector } from "react-redux";
import { useAlert, useConfirmationDialog } from "@/";
import { useNavigate } from "react-router-dom";
import { SpaceWrapper } from "../../components";
import { fetchBlogs, removeBlog, selectAllBlogs } from "../../app/Slices";
import { PhotoProvider, PhotoView } from "react-photo-view";

const Blogs = () => {
  const { alert, AlertDialog } = useAlert();
  const { confirm, ConfirmationModal } = useConfirmationDialog();
  const navigate = useNavigate();
  const handleEdit = (blog) => {
    // If blog has an _id, it means we're editing an existing blog
    if (blog && blog._id) {
      navigate("/blogs/createBlog", { state: { blog } });
    } else {
      // Otherwise, we're creating a new blog
      navigate("/blogs/createBlog");
    }
  };

  const dispatch = useDispatch();

  const fetchData = async () => {
    const response = await dispatch(fetchBlogs());
    if (fetchBlogs.fulfilled.match(response)) {
      console.log("✅ Blogs Fetched Successfully:", response.payload);
    } else if (fetchBlogs.rejected.match(response)) {
      const errorMsg = response.payload || "Failed to fetch blogs.";
      console.error("❌ Fetch Failed:", errorMsg);
      alert(errorMsg);
    }
  };
  useEffect(() => {
    fetchData();
  }, [dispatch]);

  const blogs = useSelector(selectAllBlogs) || [];

  const handleDelete = async (id) => {
    console.log(id);
    await confirm("Are you sure you want to delete this blog?");
    try {
      const response = await dispatch(removeBlog(id));
      if (removeBlog.fulfilled.match(response)) {
        console.log("✅ Blog Deleted Successfully:", response.payload);
        await alert("Blog deleted successfully.");
      } else if (removeBlog.rejected.match(response)) {
        const errorMsg = response.payload || "Failed to delete blog.";
        console.error("❌ Delete Failed:", errorMsg);
        await alert(errorMsg);
      }
    } catch (error) {
      console.error("❌ Unexpected Error:", error.message || error);
      await alert("❌ Unexpected Error:", error.message);
    }
  };

  // Format date values
  const formatDate = useCallback((dateString) => {
    return new Date(dateString).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  }, []);

  //   const pickupAddresses = useSelector(selectAllPickupAddresses) || [];
  //   const handleDelete = async (id) => {
  //     console.log(id);
  //     try {
  //       const response = await dispatch(removePickupAddress(id));

  //       if (removePickupAddress.fulfilled.match(response)) {
  //         console.log(
  //           "✅ Pickup Address Deleted Successfully:",
  //           response.payload
  //         );
  //         alert("✅ Pickup Address Deleted Successfully");
  //       } else if (removePickupAddress.rejected.match(response)) {
  //         const errorMsg = response.payload || "Failed to delete pickup address.";
  //         console.error("❌ Delete Failed:", errorMsg);
  //         alert(errorMsg);
  //       }
  //     } catch ({ error }) {
  //       console.error("❌ Unexpected Error:", error.message || error);
  //       alert("❌ Unexpected Error:", error.message);
  //     }
  //   };

  //   useEffect(() => {
  //     dispatch(fetchPickupAddresses());
  //   }, []);

  //   const isLoadingPickupAddress = useSelector(
  //     (state) => state.pickupAddress.loading
  //   );
  const columns = useMemo(
    () => [
      ColumnHelper({
        header: "S.No.",
        accessorKey: "srNo", // Matches API response
        cell: (info) => info.row.index + 1,
        meta: {
          tooltip: (row) => row.srNo,
        },
        width: "40px",
      }),
      ColumnHelper({
        header: "Image",
        accessorKey: "imageUrl", // Matches API response
        cell: (info) => {
          return (
            <div className="flex gap-1 justify-center items-center cursor-pointer">
              <PhotoProvider>
                <PhotoView src={info.row.original.imageUrl}>
                  <img
                    src={info.row.original.imageUrl}
                    alt="Blog Image"
                    className="w-24 h-12 object-cover rounded-xl bg-transparent"
                    crossOrigin="anonymous"
                  />
                </PhotoView>
              </PhotoProvider>
            </div>
          );
        },
        meta: {
          tooltip: (row) => row.imageUrl || "N/A",
        },
      }),
      ColumnHelper({
        header: "Title",
        accessorKey: "title", // Matches API response
        meta: {
          tooltip: (row) => row.title || "N/A",
        },
      }),
      ColumnHelper({
        header: "Category",
        accessorKey: "category", // Matches API response
        meta: {
          tooltip: (row) => row.category || "N/A",
        },
      }),
      ColumnHelper({
        header: "Date",
        accessorKey: "createdAt", // Matches API response
        cell: (info) =>
          info.row.original.createdAt
            ? formatDate(info.row.original.createdAt)
            : "N/A",
        meta: {
          tooltip: (row) => (row.createdAt ? formatDate(row.createdAt) : "N/A"),
        },
      }),
      ColumnHelper({
        header: "Actions",
        accessorKey: "id",
        cell: (info) => {
          return (
            <div className="flex gap-1 justify-center items-center">
              <Button size="xs" onClick={() => handleEdit(info.row.original)}>
                Edit
              </Button>

              <Button
                size="xs"
                variant="destructive"
                onClick={() => handleDelete(info.row.original._id)}
              >
                Delete
              </Button>
            </div>
          );
        },
        meta: {
          tooltip: () => "edit or delete blog",
        },
      }),
    ],
    []
  );

  const isLoading = useSelector((state) => state.blog.loading);
  return (
    <SpaceWrapper>
      <div className="w-full flex-1 flex flex-col gap-4 p-4 pb-20 md:pb-4 relative max-w-[2000px]">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row gap-4 justify-between items-end">
          <div className="flex flex-col gap-1 w-full">
            <h1 className="text-headline4 md:text-headline3 font-nunito text-secondary/95 font-semibold">
              Manage Blogs
            </h1>
            <p className="text-body2 font-ptsans text-secondary/60 lg:w-[50%]">
              Create, edit, and manage blog posts effortlessly to keep your
              audience informed and engaged.
            </p>
          </div>
          <Button
            variant="default"
            size="sm"
            icon={FaPlus}
            onClick={() => handleEdit({})}
          >
            New Blog Post
          </Button>
        </div>
        <DataTable
          columns={columns}
          tittle="Posted Blogs"
          data={blogs}
          showCheckbox={false}
          isLoading={isLoading}
        />
      </div>
      <AlertDialog />
      <ConfirmationModal />
    </SpaceWrapper>
  );
};

export default Blogs;
